import { IGestaoEpiService } from "./gestao_epi_service";
import { AxiosError } from "axios";
import { axiosInstance } from "../../../../common/utils/axios_instance";
import { handleAxiosResponse } from "../../../../common/utils/axios_response";
import { isBaseError, toBaseError } from "../../../../common/utils/base_error";
import {
  CreateGestaoEpiRequest,
  CreateGestaoEpiResponse,
} from "../daos/create/create_gestao_epi";
import {
  DeleteGestaoEpiRequest,
  DeleteGestaoEpiResponse,
} from "../daos/delete/delete_gestao_epi";
import {
  GetAllGestaoEpiRequest,
  GetAllGestaoEpiResponse,
} from "../daos/read/get_all_gestao_epi";
import {
  GetGestaoEpiByIdRequest,
  GetGestaoEpiByIdResponse,
} from "../daos/read/get_gestao_epi_by_id";
import {
  UpdateGestaoEpiRequest,
  UpdateGestaoEpiResponse,
} from "../daos/update/update_gestao_epi";
import { RequestObjectToFormData } from "../../../../common/utils/form_data_utils";
import {
  CreateGestaoRecebimentoEpiRequest,
  CreateGestaoRecebimentoEpiResponse,
} from "../daos/create/create_gestao_recebimento_epi";
import {
  DeleteGestaoRecebimentoEpiRequest,
  DeleteGestaoRecebimentoEpiResponse,
} from "../daos/delete/delete_gestao_recebimento_epi";
import {
  GetAllGestaoRecebimentoEpiRequest,
  GetAllGestaoRecebimentoEpiResponse,
} from "../daos/read/get_all_gestao_recebimento_epi";
import {
  GetGestaoRecebimentoEpiByIdRequest,
  GetGestaoRecebimentoEpiByIdResponse,
} from "../daos/read/get_gestao_recebimento_epi_by_id";
import {
  UpdateGestaoRecebimentoEpiRequest,
  UpdateGestaoRecebimentoEpiResponse,
} from "../daos/update/update_gestao_recebimento_epi";
import {
  CreateGestaoDistribuicaoEpiRequest,
  CreateGestaoDistribuicaoEpiResponse,
} from "../daos/create/create_gestao_distribuicao_epi";
import {
  DeleteGestaoDistribuicaoEpiRequest,
  DeleteGestaoDistribuicaoEpiResponse,
} from "../daos/delete/delete_gestao_distribuicao_epi";
import {
  GetAllGestaoDistribuicaoEpiRequest,
  GetAllGestaoDistribuicaoEpiResponse,
} from "../daos/read/get_all_gestao_distribuicao_epi";
import {
  GetGestaoDistribuicaoEpiByIdRequest,
  GetGestaoDistribuicaoEpiByIdResponse,
} from "../daos/read/get_gestao_distribuicao_epi_by_id";
import {
  UpdateGestaoDistribuicaoEpiRequest,
  UpdateGestaoDistribuicaoEpiResponse,
} from "../daos/update/update_gestao_distribuicao_epi";
import {
  GetGestaoEpiDropDownRequest,
  GetGestaoEpiDropDownResponse,
} from "../daos/read/get_gestao_epi_drop_down";
import {
  GetGestaoRecebimentoEpiDropDownRequest,
  GetGestaoRecebimentoEpiDropDownResponse,
} from "../daos/read/get_gestao_recebimento_epi_drop_down";
import {
  ValidacaoDistribuicaoEpiRequest,
  ValidacaoDistribuicaoEpiResponse,
} from "../daos/read/validacao_distribuicao_epi";
import { GetBiometriaRequest } from "../daos/read/get_biometria";
import {
  GetBiometriaAuditoriaRequest,
  GryfoAuditoriaResponse,
} from "../daos/read/get_biometria_auditoria";
import { DashboardEPIInfoResponse } from "../daos/read/get_dashboard_epi_info";
import {
  GetAllTermoEPIRequest,
  GetAllTermoEPIResponse,
} from "../daos/read/get_all_termo_epi";
import {
  CreateTermoEPIRequest,
  CreateTermoEPIResponse,
} from "../daos/create/create_termo_epi";
import {
  UpdateTermoEPIRequest,
  UpdateTermoEPIResponse,
} from "../daos/update/update_termo_epi";
import { DeleteTermoEPIRequest } from "../daos/delete/delete_termo_epi";
import { GetArquivoNotaFiscalRequest } from "../daos/read/get_arquivo_nota_fiscal";

/**
 * GestaoEpiService
 */

export class GestaoEpiService implements IGestaoEpiService {
  async getGestaoEpiDropDown(
    _: GetGestaoEpiDropDownRequest,
  ): Promise<GetGestaoEpiDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/gestao-epi/gestao-epi/dropdown`,
      );
      const response =
        handleAxiosResponse<GetGestaoEpiDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getGestaoRecebimentoEpiDropDown(
    request: GetGestaoRecebimentoEpiDropDownRequest,
  ): Promise<GetGestaoRecebimentoEpiDropDownResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/gestao-epi/gestao-recebimento-epi/dropdown`,
        request,
      );
      const response =
        handleAxiosResponse<GetGestaoRecebimentoEpiDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllGestaoEpi(
    request: GetAllGestaoEpiRequest,
  ): Promise<GetAllGestaoEpiResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/gestao-epi/gestao-epi`,
        formData,
        options,
      );
      const response = handleAxiosResponse<GetAllGestaoEpiResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getGestaoEpiById({
    idGestaoEpi,
  }: GetGestaoEpiByIdRequest): Promise<GetGestaoEpiByIdResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/gestao-epi/gestao-epi/${idGestaoEpi}`,
      );
      const response = handleAxiosResponse<GetGestaoEpiByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createGestaoEpi(
    request: CreateGestaoEpiRequest,
  ): Promise<CreateGestaoEpiResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/gestao-epi/gestao-epi/create`,
        formData,
        options,
      );
      const response = handleAxiosResponse<CreateGestaoEpiResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateGestaoEpi({
    idGestaoEpi,
    ...request
  }: UpdateGestaoEpiRequest): Promise<UpdateGestaoEpiResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/gestao-epi/gestao-epi/${idGestaoEpi}/update`,
        formData,
        options,
      );
      const response = handleAxiosResponse<UpdateGestaoEpiResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteGestaoEpi({
    idGestaoEpi,
  }: DeleteGestaoEpiRequest): Promise<DeleteGestaoEpiResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/gestao-epi/gestao-epi/${idGestaoEpi}/delete`,
      );
      const response = handleAxiosResponse<DeleteGestaoEpiResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllGestaoRecebimentoEpi(
    request: GetAllGestaoRecebimentoEpiRequest,
  ): Promise<GetAllGestaoRecebimentoEpiResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/gestao-epi/gestao-recebimento-epi`,
        formData,
        options,
      );
      const response =
        handleAxiosResponse<GetAllGestaoRecebimentoEpiResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getGestaoRecebimentoEpiById({
    idGestaoRecebimentoEpi,
  }: GetGestaoRecebimentoEpiByIdRequest): Promise<GetGestaoRecebimentoEpiByIdResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/gestao-epi/gestao-recebimento-epi/${idGestaoRecebimentoEpi}`,
      );
      const response =
        handleAxiosResponse<GetGestaoRecebimentoEpiByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createGestaoRecebimentoEpi(
    request: CreateGestaoRecebimentoEpiRequest,
  ): Promise<CreateGestaoRecebimentoEpiResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/gestao-epi/gestao-recebimento-epi/create`,
        formData,
        options,
      );
      const response =
        handleAxiosResponse<CreateGestaoRecebimentoEpiResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateGestaoRecebimentoEpi({
    idGestaoRecebimentoEpi,
    ...request
  }: UpdateGestaoRecebimentoEpiRequest): Promise<UpdateGestaoRecebimentoEpiResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/gestao-epi/gestao-recebimento-epi/${idGestaoRecebimentoEpi}/update`,
        formData,
        options,
      );
      const response =
        handleAxiosResponse<UpdateGestaoRecebimentoEpiResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteGestaoRecebimentoEpi({
    idGestaoRecebimentoEpi,
  }: DeleteGestaoRecebimentoEpiRequest): Promise<DeleteGestaoRecebimentoEpiResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/gestao-epi/gestao-recebimento-epi/${idGestaoRecebimentoEpi}/delete`,
      );
      const response =
        handleAxiosResponse<DeleteGestaoRecebimentoEpiResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllGestaoDistribuicaoEpi(
    request: GetAllGestaoDistribuicaoEpiRequest,
  ): Promise<GetAllGestaoDistribuicaoEpiResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/gestao-epi/gestao-distribuicao-epi`,
        formData,
        options,
      );
      const response =
        handleAxiosResponse<GetAllGestaoDistribuicaoEpiResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getGestaoDistribuicaoEpiById({
    idGestaoDistribuicaoEpi,
  }: GetGestaoDistribuicaoEpiByIdRequest): Promise<GetGestaoDistribuicaoEpiByIdResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/gestao-epi/gestao-distribuicao-epi/${idGestaoDistribuicaoEpi}`,
      );
      const response =
        handleAxiosResponse<GetGestaoDistribuicaoEpiByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createGestaoDistribuicaoEpi(
    request: CreateGestaoDistribuicaoEpiRequest,
  ): Promise<CreateGestaoDistribuicaoEpiResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/gestao-epi/gestao-distribuicao-epi/create`,
        formData,
        options,
      );
      const response =
        handleAxiosResponse<CreateGestaoDistribuicaoEpiResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateGestaoDistribuicaoEpi({
    idGestaoDistriuicaoEpi,
    ...request
  }: UpdateGestaoDistribuicaoEpiRequest): Promise<UpdateGestaoDistribuicaoEpiResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/gestao-epi/gestao-distribuicao-epi/${idGestaoDistriuicaoEpi}/update`,
        formData,
        options,
      );
      const response =
        handleAxiosResponse<UpdateGestaoDistribuicaoEpiResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteGestaoDistribuicaoEpi({
    idGestaoDistribuicaoEpi,
  }: DeleteGestaoDistribuicaoEpiRequest): Promise<DeleteGestaoDistribuicaoEpiResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/gestao-epi/gestao-distribuicao-epi/${idGestaoDistribuicaoEpi}/delete`,
      );
      const response =
        handleAxiosResponse<DeleteGestaoDistribuicaoEpiResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async validacaoDistribuicaoEpi({
    idGestaoDistribuicaoEpi,
    ...request
  }: ValidacaoDistribuicaoEpiRequest): Promise<ValidacaoDistribuicaoEpiResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/gestao-epi/gestao-distribuicao-epi/${idGestaoDistribuicaoEpi}/validacao`,
        request,
      );
      const response =
        handleAxiosResponse<ValidacaoDistribuicaoEpiResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getBiometria({
    idGestaoDistribuicaoEpi,
  }: GetBiometriaRequest): Promise<Blob> {
    try {
      const result = await axiosInstance({ responseType: "blob" }).get(
        `/gestao-epi/gestao-distribuicao-epi/getByBiometria/${idGestaoDistribuicaoEpi}`,
      );
      const response = handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getArquivoNotaFiscal({
    IdGestaoRecebimentoEpi,
  }: GetArquivoNotaFiscalRequest): Promise<Blob> {
    try {
      const result = await axiosInstance({ responseType: "blob" }).get(
        `/gestao-epi/gestao-recebimento-epi/getByNotaFiscal/${IdGestaoRecebimentoEpi}`,
      );
      const response = handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getBiometriaAuditoria(
    request: GetBiometriaAuditoriaRequest,
  ): Promise<GryfoAuditoriaResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/gestao-epi/gestao-distribuicao-epi/getByBiometriaAuditoria/`,
        { params: request },
      );
      const response = handleAxiosResponse<GryfoAuditoriaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getDashboardEPIInfo(): Promise<DashboardEPIInfoResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/gestao-epi/dashboardEPIInfo/`,
      );
      const response = handleAxiosResponse<DashboardEPIInfoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllTermosEPI(
    request: GetAllTermoEPIRequest,
  ): Promise<GetAllTermoEPIResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/gestao-epi/termoEPI/all`,
        request,
      );
      const response = handleAxiosResponse<GetAllTermoEPIResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteTermoById(request: DeleteTermoEPIRequest): Promise<void> {
    try {
      const result = await axiosInstance({}).delete(
        `/gestao-epi/termoEPI/delete`,
        { data: request },
      );
      handleAxiosResponse<void>(result);
      return;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createTermoEPI(
    request: CreateTermoEPIRequest,
  ): Promise<CreateTermoEPIResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/gestao-epi/termoEPI/create`,
        request,
      );
      const response = handleAxiosResponse<CreateTermoEPIResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateTermoEPI(
    request: UpdateTermoEPIRequest,
  ): Promise<UpdateTermoEPIResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/gestao-epi/termoEPI/update`,
        request,
      );
      const response = handleAxiosResponse<UpdateTermoEPIResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
}
